import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { api_url } from '../../../js_assets/ConfigApp';
import { GetApi, PostApi } from '../../../js_assets/Network';

import { getParameterByName } from '../../../js_assets/getParameterByName'
import Dialog from '@material-ui/core/Dialog';


import DialogTitle from '@material-ui/core/DialogTitle';
import axios from 'axios'
import AppAdminContainer from '../AppAdminContainer'
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
function Transition(props) {
    return <Slide direction="up" {...props} />;
}


const styles = theme => ({
    input: {
        paddingRight: 10,
        flex: 1,
    },
    divpadding: {
        padding: '5%'
    },
    btn_login: {
        color: 'white',
        padding: '10px 1px',
        border: 'none',
        cursor: 'pointer',
        width: '100%',
        opacity: '0.9',
        borderRadius: '3px',

    },
    btn_Resetfrom: {

        color: 'white',
    }
});

class FormProteinGuide extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
            Schedule_Package_Type_Data: [],
            loading_Save: false,
            store_Id: 0,
            successmessage: false,
            list_Citys: [],
            type_Stores: []
        };
    }



    componentDidMount() {

        const { Admin_Info } = this.state;
        axios.get(`${api_url}/api/Admin/GetCitys`)
            .then((result) => this.setState({ list_Citys: result.data }))
            .catch(function (error) {

                //console.log(error);
            })

        axios.get(`${api_url}/api/Guide/GetType_Stores`)
            .then((result) => this.setState({ type_Stores: result.data }))
            .catch(function (error) {

                //console.log(error);
            })


        let StoreId = getParameterByName("StoreId")


        if (StoreId !== null) {

            if (StoreId === "New") {

                //console.log("it new ")
            } else {

                //console.log("it number " + StoreId)

                this.setState({ store_Id: StoreId })

                GetApi(`/api/Admin/GetGuide/${StoreId}/${Admin_Info.admin_Id}`, Admin_Info.jwT_Token_Admin)
                    .then(result => {

                        //console.log(result);



                        this.refs.store_Name.value = result.store_Name;
                        this.refs.type_Store_Id.value = result.type_Store_Id;
                        this.refs.store_Location.value = result.store_Location;
                        this.refs.store_Description.value = result.store_Description;
                        this.refs.social_Media_Link.value = result.social_Media_Link;
                        this.refs.store_Link_Location.value = result.store_Link_Location;
                        this.refs.store_Image.value = result.store_Image;
                        this.refs.description_Of_Place.value = result.description_Of_Place;



                    })
            }

        }



    }



    Save_Health_Trainer = (e) => {


        e.preventDefault();
        this.setState({ loading_Save: true });
        var data = new FormData();

        const { Admin_Info } = this.state;



        //console.log(this.refs.type_Store_Id.value);



        if (this.refs.ImageUP.files.length !== 0) {
            //console.log("it  img")
            data.append("UploadedImage", this.refs.ImageUP.files[0]);

            axios.post(`${api_url}/api/Admin/SaveImageGuide`, data, { headers: { 'Content-type': 'application/json; charset=utf-8' } })
                .then(result => {


                    let StoreData = {
                        admin_Id: parseInt(Admin_Info.admin_Id),
                        store_Id: parseInt(this.state.store_Id),
                        store_Name: this.refs.store_Name.value,
                        type_Store_Id: parseInt(this.refs.type_Store_Id.value),
                        store_Location: parseInt(this.refs.store_Location.value),
                        store_Description: this.refs.store_Description.value,
                        social_Media_Link: this.refs.social_Media_Link.value,
                        store_Link_Location: this.refs.store_Link_Location.value,
                        store_Image: result.data,
                        description_Of_Place: this.refs.description_Of_Place.value
                    }



                    PostApi(`/api/Admin/Save_Guide/${Admin_Info.admin_Id}`, StoreData, Admin_Info.jwT_Token_Admin)
                        .then(() => {

                            this.setState({ loading_Save: false, successmessage: true });

                        })

                })
                .catch(function (error) {
                    //console.log(error);
                });



        } else {

            let StoreData = {
                admin_Id: parseInt(Admin_Info.admin_Id),
                store_Id: parseInt(this.state.store_Id),
                store_Name: this.refs.store_Name.value,
                type_Store_Id: parseInt(this.refs.type_Store_Id.value),
                store_Location: parseFloat(this.refs.store_Location.value),
                store_Description: this.refs.store_Description.value,
                social_Media_Link: this.refs.social_Media_Link.value,
                store_Link_Location: this.refs.store_Link_Location.value,
                store_Image: this.refs.store_Image.value,
                description_Of_Place: this.refs.description_Of_Place.value
            }


            PostApi(`/api/Admin/Save_Guide/${Admin_Info.admin_Id}`, StoreData, Admin_Info.jwT_Token_Admin)
                .then(() => {

                    this.setState({ loading_Save: false, successmessage: true });

                })

        }










    }

    handlClosesuccessmessage = () => {
        this.setState({ successmessage: false })
    }

    render() {
        const { classes } = this.props;
        const { loading_Save, list_Citys, type_Stores } = this.state;

        let optionItemsCity = list_Citys.map((citys) => <option value={citys.city_Id} key={citys.city_Id}>{citys.city_Name}</option>);
        let optionItemstype_Stores = type_Stores.map((type_Stores) => <option value={type_Stores.type_Store_Id} key={type_Stores.type_Store_Id}>{type_Stores.type_Store_Name}</option>);
        return (

            <AppAdminContainer Title={"الدليل"}>
                <Dialog
                    open={this.state.successmessage}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handlClosesuccessmessage}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="alertIcon">✔️ <label>تم حفظ </label></div>
                    </DialogTitle>


                </Dialog>

                <form onSubmit={this.Save_Health_Trainer} acceptCharset={"multipart/form-data"}>

                    <input ref="StoreId" value={this.state.store_Id} />


                    <div >
                        <i className="fa-icon"> اسم المتجر</i>
                        <input placeholder="اسم المتجر " name="store_Name" ref="store_Name" required />
                    </div>

                    <div >
                        <i className="fa-icon"> نوع المتجر</i>
                        <select name="type_Store_Id" ref="type_Store_Id" required>
                            {optionItemstype_Stores}
                        </select>
                    </div>
                    <div >
                        <i className="fa-icon"> موقع المتجر</i>
                        <select name="store_Location" ref="store_Location" required>
                            {optionItemsCity}
                        </select>
                    </div>
                    <div >

                        <textarea rows={7} placeholder="وصف المتجر" name="store_Description" ref="store_Description" required />
                    </div>
                    <div >
                        <i className="fa-icon"> حساب التواصل</i>
                        <input placeholder="حساب التواصل الاجتماعي" name="social_Media_Link" ref="social_Media_Link" required />
                    </div>
                    <div >
                        <i className="fa-icon"> قوقل ماب </i>
                        <input placeholder="رابط قوقل ماب" name="store_Link_Location" ref="store_Link_Location" required />
                    </div>
                    <div >
                        <i className="fa-icon">  وصف المكان </i>
                        <input placeholder="وصف المكان" name="description_Of_Place" ref="description_Of_Place" required />
                    </div>

                    <input ref="store_Image" /><br></br>

                    <label>صورة </label>
                    <input type="file" ref='ImageUP' accept="image/*" name="fileInput" />
                    <div >
                        <button variant="contained" type="Submit" color="primary" className={classes.btn_login}  >
                            {loading_Save === true ? <CircularProgress size={25} color={"secondary"} /> : <label>حفظ</label>}

                        </button>

                    </div>

                </form>

            </AppAdminContainer >




        )
    }


}
FormProteinGuide.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FormProteinGuide);